<mat-card fxFlex="75" class="profile">
    <mat-card-content class="full" fxLayout="column">
        <div class="profileBanner">
            <span class="loader" [class.d-none]="!bannerLoading"></span>
            <!-- <div class="shimmer" ></div> -->
            <img class="background" [class.d-none]="bannerLoading" [src]="myProfileObject.cover_picture?.document_file"
                alt="cover picture">
            <app-file-field [showUploadedList]="false" [fileDropArea]="false" [isEditable]="false" [cameraIcon]="true"
                [class.hidden]="profileLoading" [ngModel]="myProfileObject.cover_picture" class="bannerfile"
                [documentTypeDevName]="'profile_picture'" [name]="'cover_picture'" [multiple]="false"
                (ngModelChange)="uploadCover($event)" (loadingFileChange)="loadingCover($event)" [cropper]="true">
            </app-file-field>
            <!-- <div class="floating-icon">
                <i class="flaticon-container" *ngFor="a of "></i>
            </div> -->
            <!--            <ng-particles class="background" id="tsparticles" [options]="particlesOptions"-->
            <!--                [particlesInit]="particlesInit">-->
            <!--            </ng-particles>-->
            <!-- <i class="flaticon-pencil"></i> -->
        </div>
        <div class="profileImg">
            <!-- <img [src]="profile_pic!=null?profile_pic?.document_file:
            myProfileObject.gender=='Male'?base_url+'/media/profile_pics/man.svg':
            myProfileObject.gender=='Female'?base_url+'/media/profile_pics/woman.svg':
            base_url+'/media/profile_pics/default_dp.svg'" alt="Profile Picture"> -->
            <div class="loadingProfileImg" *ngIf="profileLoading">

            </div>
            <logzy-img-loader [src]="profile_pic!=null?profile_pic?.document_file:
                myProfileObject.gender=='Male'?base_url+'/media/profile_pics/man.svg':
                myProfileObject.gender=='Female'?base_url+'/media/profile_pics/woman.svg': 
                base_url+'/media/profile_pics/default_dp.svg'" border_radius="50%" [profilePic]="true"
                [initial]="profile_pic==null" [initials]="myProfileObject?.initials"></logzy-img-loader>
            <!-- <i class="flaticon-camera"></i> -->
            <app-file-field [showUploadedList]="false" [fileDropArea]="false" [isEditable]="false" [cameraIcon]="true"
                [class.hidden]="profileLoading" [ngModel]="myProfileObject.picture"
                [documentTypeDevName]="'profile_picture'" [name]="'picture'" [cropper]="false"
                (loadingFileChange)="loadingProfile($event)" [multiple]="false" (ngModelChange)="uploadDp($event)"
                [fileUploadUrl]="profile_pic_upload_url">
            </app-file-field>
        </div>
        <div class="profileContent " fxLayout="row wrap">
            <div fxFlex="100" class="headCover">
                <div class="head" fxLayout="column">
                    <mat-card-title>{{myProfileObject.first_name}} {{myProfileObject.last_name}}</mat-card-title>
                    <span>{{myProfileObject.profile_role?.name}}</span>
                    <i *ngIf="!isProfileEditable" class="flaticon-pencil" (click)="editProfileToggle()"></i>
                    <i *ngIf="isProfileEditable" class="flaticon-save" (click)="editProfile()"></i>
                </div>
            </div>
            <div fxFlex="100" class="inputs" fxLayout="row wrap">
                <!-- First Name -->
                <app-text-field class="align-items-center" [isEditable]="isProfileEditable" [label]="'First Name'"
                    [(ngModel)]="myProfileObject.first_name" [name]="'first_name'" fxFlex="100" fxFlex.gt-xs="13.8em"
                    fxLayout="column" [errors]="errorObj.first_name">
                </app-text-field>

                <!-- Last Name -->
                <app-text-field class="align-items-center" [isEditable]="isProfileEditable" [label]="'Last Name'"
                    [(ngModel)]="myProfileObject.last_name" [name]="'last_name'" fxFlex="100" fxFlex.gt-xs="13.8em"
                    fxLayout="column" [errors]="errorObj.last_name">
                </app-text-field>

                <!-- Email Address -->
                <app-text-field class="align-items-center wordWrap" [isEditable]="false" [label]="'Email Address'"
                    [(ngModel)]="myProfileObject.email" [name]="'email'" fxFlex="100" fxFlex.gt-xs="13.8em"
                    fxLayout="column" [errors]="errorObj.email">
                </app-text-field>

                <!-- Mobile Number -->
                <app-phone-field [isEditable]="isProfileEditable" [label]="'Mobile No'" [name]="'mobile_number'"
                    [(ngModel)]="myProfileObject.mobile_number" [errors]="errorObj.mobile_number" fxFlex="100"
                    fxFlex.gt-xs="13.8em" fxLayout="column" class="align-items-center">
                </app-phone-field>

                <!-- Gender -->
                <app-toggle-select [isEditable]="isProfileEditable" [label]="'Sex'" [(ngModel)]="myProfileObject.gender"
                    [name]="'gender'" [options]="genderOptions" [errors]="errorObj.gender" fxFlex="100"
                    fxFlex.gt-xs="13.8em" fxLayout="column" class="align-items-center">
                </app-toggle-select>

                <!-- Country -->
                <app-mat-auto-search class="align-items-center" [isEditable]="isProfileEditable" [label]="'Country*'"
                    [name]="'country'" [(ngModel)]="myProfileObject.country" [idField]="null" [setSearchValue]="false"
                    [listUrl]="country_url+'country/?name=::search::'" [displayField]="'name'"
                    [errors]="errorObj.country" fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                </app-mat-auto-search>

                <!-- Profile Role -->
                <app-text-field class="align-items-center" [isEditable]="false" [label]="'Role'" [name]="'role'"
                    [ngModel]="myProfileObject.profile_role?.name" [errors]="errorObj.profile_role" fxFlex="100"
                    fxFlex.gt-xs="13.8em" fxLayout="column">
                </app-text-field>

                <!-- Designation -->
                <app-text-field class="align-items-center" [isEditable]="isProfileEditable" [label]="'Designation*'"
                    [(ngModel)]="myProfileObject.designation" [name]="'designation'" [errors]="errorObj.designation"
                    fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                </app-text-field>

                <!-- Upload E-Signature -->
                <div fxFlex="100" class="justify-content-flex-start align-items-flex-start" fxFlex.gt-xs="13.8em"
                    fxLayout="column">
                    <div class="inputTitle">
                        <span>Upload e-signature</span>
                    </div>
                    <app-file-field [showUploadedList]="false" [fileDropArea]="false" [isEditable]="isProfileEditable"
                        [(ngModel)]="myProfileObject.e_sign" [documentTypeDevName]="'profile_picture'" [name]="'e_sign'"
                        [label]="'Upload e-Sign'" [isSolidUploadIcon]="true" [multiple]="false">
                    </app-file-field>
                    <div *ngIf="!isProfileEditable" class="editableSign">
                        <ng-container *ngIf="myProfileObject.e_sign!=null">
                            <img [src]="myProfileObject.e_sign?.document_file" alt="e-Signature">
                            <div fxLayout="column" class="align-items-flex-start">
                                <span>{{myProfileObject.e_sign?.original_filename}}.{{myProfileObject.e_sign?.extension}}</span>
                                <span>{{myProfileObject.e_sign?.created_at|date:"dd MMM, yyyy"}}</span>
                                <span>{{embassyService.readableFileSize(myProfileObject.e_sign?.size)}}</span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="myProfileObject.e_sign==null">-</ng-container>
                    </div>
                    <div *ngIf="upload && isProfileEditable">
                        <small class="logoText">Only PNG, JPG/JPEG upto 3 MB size allowed.</small>
                    </div>
                    <div *ngIf="logo">
                        <small class="logoText">logo.png 500Kb</small>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
<mat-card fxFlex="20" class="socialCard">
    <mat-card-content class="p10" fxLayout="column">
        <mat-card-title>Social Info</mat-card-title>
        <i *ngIf="!isProfileEditable" class="flaticon-pencil" (click)="editProfileToggle()"></i>
        <i *ngIf="isProfileEditable" class="flaticon-save" (click)="editProfile()"></i>
        <div fxFlex="100" class="inputs socialInfo" fxLayout="row wrap">
            <!-- Date Of Birth -->
            <app-date-field [isEditable]="isProfileEditable" [label]="'Date of Birth'" [maxDate]="currentDate"
                [(ngModel)]="myProfileObject.date_of_birth" [name]="'date_of_birth'" [errors]="errorObj.date_of_birth"
                fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
            </app-date-field>

            <!-- Anniversary Date -->
            <app-date-field [isEditable]="isProfileEditable" [label]="'Anniversary Date'" [maxDate]="currentDate"
                [(ngModel)]="myProfileObject.anniversary_date" [name]="'anniversary_date'" fxFlex.gt-xs="13.8em"
                [errors]="errorObj.anniversary_date" fxFlex="100" fxLayout="column">
            </app-date-field>

            <!-- LinkedIn Profile -->
            <app-text-field [isEditable]="isProfileEditable" [label]="'Linkedin Profile'"
                [(ngModel)]="myProfileObject.linked_in_profile" [name]="'linked_in_profile'" fxFlex.gt-xs="13.8em"
                [errors]="errorObj.linked_in_profile" fxFlex="100" fxLayout="column">
            </app-text-field>

            <!-- Whatsapp Number -->
            <app-phone-field [isEditable]="isProfileEditable" [label]="'WhatsApp'"
                [(ngModel)]="myProfileObject.whatsapp_number" [name]="'whatsapp_number'" fxFlex.gt-xs="13.8em"
                [errors]="errorObj.whatsapp_number" fxFlex="100" fxLayout="column">
            </app-phone-field>
            <img class="social" src="assets/images/backgrounds/social.gif" alt="" fxFlex="13em">
        </div>

    </mat-card-content>
</mat-card>
<mat-card fxFlex="100" fxLayout="column">
    <mat-card-content class=" p10 content">
        <div class="compInfo">
            <mat-card-title>Company Info</mat-card-title>
            <i *ngIf="!isCompanyEditable && current_user.role=='admin'" class="flaticon-pencil"
                (click)="editCompanyToggle()"></i>
            <i *ngIf="isCompanyEditable && current_user.role=='admin'" class="flaticon-save"
                (click)="editCompany()"></i>
        </div>
        <div fxFlex="100" class="inputs p15" fxLayout="row wrap">
            <!-- Company Name -->
            <app-text-field [isEditable]="isCompanyEditable" [label]="'Company Name'"
                [(ngModel)]="myProfileObject.company_name" [name]="'company_name'" fxFlex="100" fxFlex.gt-xs="13.8em"
                fxLayout="column" [errors]="errorObj.company_name" class="align-items-center">
            </app-text-field>

            <!-- Company Website -->
            <app-text-field [isEditable]="isCompanyEditable" [label]="'Company Website'"
                [(ngModel)]="myProfileObject.company_website" [name]="'company_website'" fxFlex="100"
                fxFlex.gt-xs="13.8em" fxLayout="column" [errors]="errorObj.company_website" class="align-items-center">
            </app-text-field>

            <!-- Company Address -->
            <app-text-field [isEditable]="isCompanyEditable" [label]="'Company Address'"
                [(ngModel)]="myProfileObject.company_address" [name]="'company_address'" [isMultiline]="true"
                fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column" [errors]="errorObj.company_address"
                class="align-items-center">
            </app-text-field>

            <!-- Company Logo Upload -->
            <div fxFlex="100" class="justify-content-flex-start align-items-flex-start" fxFlex.gt-xs="13.8em"
                fxLayout="column">
                <div class="inputTitle">
                    <span>Company Logo</span>
                </div>
                <app-file-field [showUploadedList]="false" [fileDropArea]="false" [isEditable]="isCompanyEditable"
                    [(ngModel)]="myProfileObject.company_logo" [documentTypeDevName]="'profile_picture'"
                    [name]="'company_logo'" [label]="'Upload Logo'" [isSolidUploadIcon]="true" [multiple]="false"
                    class="align-items-center companyfile" *ngIf="isCompanyEditable">
                </app-file-field>
                <span *ngIf="isCompanyEditable"
                    class="companyLogoInfo">{{myProfileObject?.company_logo?.original_filename}}.{{myProfileObject?.company_logo.extension}}
                    [ <u>{{embassyService.readableFileSize(myProfileObject?.company_logo.size)}}</u> ] </span>
                <div *ngIf="!isCompanyEditable && myProfileObject.company_logo!=null" class="companyLogo">
                    <img id="company_logo" [src]="myProfileObject?.company_logo?.document_file" alt="Company Logo">
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>